import {Component, Vue} from 'vue-property-decorator'
import GroupUsers from '@/components/group-users/index.vue'
import user_module from "@/modules/user";
import Loader from '@/components/loader/Loader.vue';

@Component({
    components: {
        GroupUsers,
        Loader
    }
})

export default class Userinfo extends Vue {

    loading: boolean = false;
    advInfo: string = '';

    get fullName(){

        return user_module.userInfo.UserName
    }
    
    get email(){

        return user_module.userInfo.Email;
    }

    get login (){

        return user_module.userInfo.Login;
    }

    get hasGroupUsers () {
        return user_module.hasGroupUsers;
    }

    get preparedUserInfo(){

        const {userInfo}: any = user_module;

        type UserInfoItem = {[key: string]: string}

        const createUserItem = (field: string, ...values: string[]) => {

            return {

                field,
                value: values.join(' ')
            }   
        }

        const pwdDate = userInfo['ChPwdDate'];

        let preparedDate = '';

        if (pwdDate){


            const monthes = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

            const year = pwdDate.slice(0, 4);
            const month = pwdDate.slice(4, 6);
            const day = pwdDate.slice(6, 8);

            const monthStr = monthes[Number(month) - 1];
            preparedDate = monthStr + ' ' + day + ', ' + year;

        }

        const preparedUserInfo: {[key: string]: UserInfoItem} = {}

        preparedUserInfo['Login'] = createUserItem('Login', userInfo['Login']);
        preparedUserInfo['Name'] = createUserItem('Name', userInfo['FName'], userInfo['LName']);

        preparedUserInfo['PwdDate'] = createUserItem('Password Expiration Date', preparedDate);
        preparedUserInfo['Company'] = createUserItem('Company', userInfo['Company']?.Name);
        // preparedUserInfo['CompanyID'] = createUserItem('Company ID', userInfo['Company']?.ID);
        
        preparedUserInfo['Email'] = createUserItem('Email', userInfo['Email']);

        // const expireDateMS = userInfo['ExpireDate'];
        // const expireDate = expireDateMS ? String(new Date(Number(expireDateMS))) : "";s
        // preparedUserInfo['ExpireDate'] = createUserItem('Expire Date', expireDate);
        
        const phone = userInfo['Phone'];
        
        if (phone){

            let preparedPhoneValue = phone;

            if (!isNaN(Number(phone))){

                preparedPhoneValue = phone.replace(/(\d{1,3})(\d{1,3})(\d{1,4})/g, '$1-$2-$3');

            }

            preparedUserInfo['Phone'] = createUserItem('Phone', preparedPhoneValue);
        }
        // preparedUserInfo['StartDate'] = createUserItem('Start date', userInfo['StartDate']);

        const fullAddress = [userInfo['Address2'], userInfo['City'], userInfo['State'], userInfo['ZIP']].filter(i => i).join(', ')

        if (fullAddress){
            preparedUserInfo['User Address'] = createUserItem('Address', fullAddress);
        }


        return preparedUserInfo;
    }

    get AILicense(){
        return user_module.licenses.find(l => l.ProductCode === 'AI');
    }

    async saveAdvInfo(){
        this.loading = true;
        try{
            await user_module.saveAdvInfo(this.advInfo);

            this.$toasted.success('Adviser info saved', {
                duration: 4000
            });

        } catch (err){

            console.log('err!!!', err);

            this.$toasted.error('Something wrong', {
                duration: 4000
            });        
        }
        
        this.loading = false;
    }

    created(){

        if  (user_module.settingAdvInfo &&  user_module.settingAdvInfo.Info){
            this.advInfo = JSON.parse(user_module.settingAdvInfo.Info);
        }
    }
}